import { useRef } from "react";
import { Link } from "react-router-dom";
import logo from "../Images/Logo4.png";
import torch from "../Images/Torch.png";

export const Nav = () => {
  const navbarCollapseRef = useRef(null);

  const handleNavLinkClick = () => {
    if (navbarCollapseRef.current?.classList.contains("show")) {
      const bsCollapse = new window.bootstrap.Collapse(
        navbarCollapseRef.current,
        {
          toggle: false,
        }
      );
      bsCollapse.hide();
    }
  };
  return (
    <nav className="navbar navbar-expand-lg bg-light shadow-sm sticky-top p-1">
      <div className="container-fluid px-4">
        <Link className="navbar-brand d-flex align-items-center gap-2" to="/">
          <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-3">
            <img
              src={logo}
              alt="ProCoatify Logo"
              width="90"
              height="90"
              className="img-fluid"
            />
            {/* <img
              src={torch}
              alt="ProCoatify Torch"
              width="100"
              height="100"
              className="img-fluid"
            /> */}
          </div>
        </Link>

        <button
          className="navbar-toggler border-0 text-gold"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon bg-gold"></span>
        </button>

        <div
          className="collapse navbar-collapse justify-content-end"
          id="navbarSupportedContent"
          ref={navbarCollapseRef}
        >
          <ul className="navbar-nav gap-3 fs-3">
            {[
              { to: "/", label: "Home" },
              { to: "/aboutus", label: "About Us" },
              { to: "/products", label: "Products" },
              { to: "/projects", label: "Projects" },
              { to: "/contactus", label: "Contact Us" },
            ].map((item) => (
              <li className="nav-item" key={item.to}>
                <Link
                  className="nav-link hover-underline"
                  to={item.to}
                  onClick={handleNavLinkClick}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};
